import { QuilttSessionTokenResponse } from './useQuilttSessionToken.interface';

import collectiveApi from 'modules/common/collectiveApi';

const fetchQuilttSessionToken = async (): Promise<QuilttSessionTokenResponse> => {
    const { data } = await collectiveApi.post<QuilttSessionTokenResponse>('quiltt/session-token/');
    return data;
};

export default fetchQuilttSessionToken;
